<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='form' label-width='120px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='批次号：'>
          <el-input v-model='form.batchNumber' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号：'>
          <el-input v-model='form.waybillNo' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号：'>
          <el-input v-model='form.frameNumber' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"></el-input>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='form.brandName' size='mini' placeholder='请输入品牌'></el-input>
        </el-form-item>
        <el-form-item label='库场：'>
          <el-input v-model='form.depot' size='mini' placeholder='请输入库场'></el-input>
        </el-form-item>
        <el-form-item label='港口名称：'>
          <el-input v-model='form.portName' size='mini' placeholder='请输入港口名称'></el-input>
        </el-form-item>
        <el-form-item label='入库时间：'>
          <el-date-picker
            v-model='warehouseTime'
            value-format='yyyy-MM-dd'
            size='mini'
            type='daterange'
            align='right'
            unlink-panels
            range-separator='-'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='出库时间：'>
          <el-date-picker
            v-model='outWarehouseTime'
            value-format='yyyy-MM-dd'
            size='mini'
            type='daterange'
            align='right'
            unlink-panels
            range-separator='-'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='状态：'>
          <el-select v-model='form.state' filterable size='mini' style='width:140px'
                     placeholder='请选择状态'>
            <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                       :value='item.value' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#3B3B3B','font-size':'13px','height':'42px',}"
        >
          <el-table-column type='index' label='序号' align='center' width='60' />
          <el-table-column prop='portName' label='港口名称' align='center' />
          <el-table-column prop='batchNumber' label='批次号' align='center' width='200' />
          <el-table-column prop='waybillNo' label='运单编号' align='center' width='200' />
          <el-table-column prop='frameNumber' label='车架号' align='center' width='200' />
          <el-table-column prop='brandName' label='品牌' align='center' />
          <el-table-column prop='modelName' label='型号' align='center' />
          <el-table-column prop='depot' label='库场' align='center' />
          <el-table-column prop='position' label='位置' align='center' />
          <el-table-column prop='enterWarehousePeople' label='入库扫码人' align='center' />
          <el-table-column label='入库时间' align='center' width='100' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.enterDate |formatTime }}
            </template>
          </el-table-column>
          <el-table-column label='出库时间' align='center' width='100' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.outDate |formatTime }}
            </template>
          </el-table-column>
          <el-table-column label='核定时间' align='center' width='100' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.locationDate |formatTime }}
            </template>
          </el-table-column>
          <el-table-column prop='locationWarehousePeople' label='核定扫码人' align='center' />
          <el-table-column prop='driverBarcode' label='司机条码' align='center' />
          <el-table-column label='状态' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.state ? '已出库' : '未出库' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { formatTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { getWarehouseList } from '@/service/getData';

  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        form: {
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brandName: '',
          depot: '',
          portName: '',
          warehouseStartTime: '',
          warehouseStopTime: '',
          outWarehouseStartTime: '',
          outWarehouseStopTime: '',
          state: '',
          page:1,
          rows:10,
        },
        defaultForm: {},
        warehouseTime: [],
        outWarehouseTime: [],
        tableLoading: false,
        tableData: [],
        total: 0,
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '未出库',
          },
          {
            value: 1,
            label: '已出库',
          },
        ],
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
      // this.getWarehouseList();
    },
    filters: {
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
        }
        return '';
      },
    },
    methods: {
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/warehouse/warehouseExport?access_token=${token}&batchNumber=${this.form.batchNumber}&waybillNo=${this.form.waybillNo}&frameNumber=${this.form.frameNumber}&brandName=${this.form.brandName}&depot=${this.form.depot}&warehouseStartTime=${this.form.warehouseStartTime}&warehouseStopTime=${this.form.warehouseStopTime}&outWarehouseStartTime=${this.form.outWarehouseStartTime}&outWarehouseStopTime=${this.form.outWarehouseStopTime}&state=${this.form.state}`;
        window.exportExcelGet('/platform/warehouse/warehouseExport', `batchNumber=${this.form.batchNumber}&waybillNo=${this.form.waybillNo}&frameNumber=${this.form.frameNumber}&brandName=${this.form.brandName}&depot=${this.form.depot}&portName=${this.form.portName}&warehouseStartTime=${this.form.warehouseStartTime}&warehouseStopTime=${this.form.warehouseStopTime}&outWarehouseStartTime=${this.form.outWarehouseStartTime}&outWarehouseStopTime=${this.form.outWarehouseStopTime}&state=${this.form.state}`)
      },
      async getWarehouseList() {
        this.form.warehouseStartTime = this.warehouseTime[0] || '';
        this.form.warehouseStopTime = this.warehouseTime[1] || '';
        this.form.outWarehouseStartTime = this.outWarehouseTime[0] || '';
        this.form.outWarehouseStopTime = this.outWarehouseTime[1] || '';
        this.tableLoading = true;
        const {
          data,
          status,
          message,
        } = await getWarehouseList(this.form);
        this.tableLoading = false;
        if (status !== 0) return this.$message.error(message);
        this.total = data.total;
        this.tableData = data.records;
      },
      // 主页面条数
      contractSizeChange(row) {
        this.form.rows = row;
        this.form.page = 1;
        this.getWarehouseList();
      },
      // 主页面页数
      contractCurrentChange(page) {
        this.form.page = page;
        this.getWarehouseList();
      },
      // 查询
      searchBtn() {
        this.form.page = 1;
        this.getWarehouseList();
      },
      resetBtn() {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.warehouseTime = [];
        this.outWarehouseTime = [];
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.form.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    /*background-color: #fff;*/

    .exportButton {
      span {
        color: rgba(51, 136, 255, 1);
        margin-right: 10px;
        font-size: 14px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        //bottom:0;
        top: 0;
        left: 0;
        color: #FFF;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          line-height: 30px;
          font-weight: 500;
          color: #101010;
        }

        .el-form-item__content {
          line-height: 30px;
        }

        .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 220px;
        }

        .el-form--inline .el-form-item__label {
          display: inline;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 5px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #F56C6C !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;

          &Nav {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .addCost {
      display: flex;
      flex-direction: column;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      &Table {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox:after {
            color: rgb(127, 127, 127);
            content: "全选";
            font-size: 12px;
            font-weight: 700;
            //margin-left: 2px;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox {
            margin-left: 8px;
          }

          .el-checkbox {
            margin-left: 16px;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;

        .imgLength {
          display: flex;
          align-items: center;
          width: 90%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      &Table {
        margin-bottom: 25px;
        width: 100%;

        .tableAddBtnContainer {
          border: 1px solid #EBEEF5;;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #F59A23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .spanStyle {
    color: rgb(51, 136, 255);
    cursor: pointer;
    margin-left: 10px;
  }
</style>
